import React from 'react';

class CardList extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            items: this.props.items||[]
        };
    }
    
    static defaultProps = {
        items: [
            {heading:"Vuedoo", context:"warning", content:"The process completed, but the write disk is at 10% remaining.", ts:"11.12.2019T8:02:10.35Z", button:"Details", url:"./"},
            {heading:"Esque", context:"success", content:"The process completed successfully.", ts:"11.12.2019T8:00:20.10Z"},
            {heading:"Nachure", context:"success", content:"The process completed successfully.", ts:"11.12.2019T7:59:33.12Z"},
            {heading:"Admine", context:"danger", content:"The process completed, but an error occured.", ts:"11.12.2019T7:57:04.13Z", button:"Details", url:"./"}
        ],
        className: "",
        headerClasses: ""
    };

    render(){
        var { items } = this.state;
        return (
            <div className={this.props.className}>
                {items && items.length > 0 ? items.map((item,key) =>(
                <div className="card mb-3 shadow-sm" key={key}>
                    <div className="card-body">
                        <span className="float-right text-muted small">{item.ts}</span>
                        <h5 className="card-title"><span className={'badge badge-pill bg-'+item.context}>&nbsp;</span> {item.heading}</h5>
                        <p className="card-text">{item.content} {(item.button)?<button className={'btn btn-sm align-bottom ml-3 btn-outline-'+item.context}>Details</button>:''}</p>
                    </div>
                </div>
                 )):''}
            </div>
        );
    }
}

export default CardList;